import { CONSENT_EVENT, CONSENT_KEY, CONSENT_VERSION, type CookieConsent } from './types.js';

function isBrowser() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function getConsent(): CookieConsent | null {
  if (!isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const consent = JSON.parse(raw) as CookieConsent;
    if (!consent?.acceptedAt || typeof consent.accepted !== 'boolean') return null;
    if (consent.version !== CONSENT_VERSION) return null;
    return consent;
  } catch {
    return null;
  }
}

export function setConsent(accepted: boolean): CookieConsent {
  const consent: CookieConsent = {
    accepted,
    acceptedAt: new Date().toISOString(),
    version: CONSENT_VERSION,
  };
  if (!isBrowser()) return consent;
  window.localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  window.dispatchEvent(
    new CustomEvent<CookieConsent>(CONSENT_EVENT, {
      detail: consent,
    }),
  );
  return consent;
}

export function clearConsent(): void {
  if (!isBrowser()) return;
  window.localStorage.removeItem(CONSENT_KEY);
}

export function hasConsent(): boolean {
  const consent = getConsent();
  return Boolean(consent?.accepted);
}
